(() => {
  const initCompare = (root) => {
    const sections = root.querySelectorAll('[data-dartsrx-compare]');

    sections.forEach((section) => {
      const tabs = section.querySelectorAll('[data-dartsrx-compare-tab]');
      const panels = section.querySelectorAll('[data-dartsrx-compare-panel]');

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const target = tab.dataset.dartsrxCompareTab;

          tabs.forEach((item) => {
            const isActive = item === tab;
            item.classList.toggle('is-active', isActive);
            item.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });

          panels.forEach((panel) => {
            panel.classList.toggle('is-active', panel.dataset.dartsrxComparePanel === target);
          });
        });
      });
    });
  };

  initCompare(document);

  document.addEventListener('shopify:section:load', (event) => {
    initCompare(event.target);
  });
})();
